/**
 * Where a game in an admin list leads. Admin lists point at the scoreboard —
 * the reason to pick a game out of an admin list is to score it — rather than
 * at the public game page the same list control links to on the public side.
 *
 * Kept next to the admin pages that use it so the route is written once; it
 * must match the `games/:gameId/score` route nested under `seasons/:seasonId`
 * in App.tsx.
 */
export function adminGameUrl(seasonId: number, gameId: number): string {
  return `/admin/seasons/${seasonId}/games/${gameId}/score`;
}
